<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="网络货运平台端" name="0">
        <img src="/static/images/introduce-wlhy-1.png" >
      </el-tab-pane>
      <el-tab-pane label="司机小程序" name="1">
        <img src="/static/images/introduce-wlhy-2.png" >
      </el-tab-pane>
      <el-tab-pane label="业务员小程序" name="2">
        <img src="/static/images/introduce-wlhy-3.png" >
      </el-tab-pane>
    </el-tabs>
    <div class="detail">成易网运物流管理是一款结合网络货运行业特点打造的物流平台。系统可实现创建运单、在途跟踪、到站签收、运费结算、开票等流程，帮助物流企业、平台(成易网运)、司机三方实现信息的互联互通。</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: '0'
      }
    },
    mounted: function() {
      if (this.$global.getUrlKey("tab")) this.activeName = this.$global.getUrlKey("tab");
    }
  }
</script>

<style>
  .el-tabs__header {
    margin-bottom: 22px;
  }
  
  .el-tabs__nav-wrap:after {
    background-color: transparent;
  }
  
  .el-tabs__active-bar {
    width: 50px;
    height: 3px;
    background-color: #fff;
    border-radius: 1.5px;
  }
  
  .el-tabs__item {
    font-size: 16px;
    color: #e1e1e1;
  }
  
  .el-tabs__item.is-active,.el-tabs__item:hover {
    font-size: 18px;
    color: #fff;
  }
  
  .stance {
    height: 41px;
    margin-bottom: 22px;
  }
  
  .detail {
    margin-top: 25px;
    font-size: 14px;
    color: #e1e1e1;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/wlhy.vue